import React, { useState, useEffect } from "react";
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import Parallax from "../common/utils/animations/parallax";

export default function TechnologySlider(props) {
  const { items, classes, platforms } = props.data;
  console.log(props.data);

  const [isMobile, setisMobile] = useState(false);

  const setValues = () => {
    setisMobile(window.innerWidth <= 767);
  };
  useEffect(() => {
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });


  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 7,
    autoplaySpeed: 2000,
    autoplay: true,
    rows: 2,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
    ]
  };

  const triggers = [[1, 0.9], [0.95, 0.85], [0.9, 0.8], [0.85, 0.75]];
  const triggers2 = [[1, 0.95], [0.97, 0.92], [0.94, 0.89], [0.91, 0.86], [0.88, 0.83], [0.85, 0.8], [0.82, 0.77], [1, 0.95], [0.97, 0.92], [0.94, 0.89], [0.91, 0.86], [0.88, 0.83], [0.85, 0.8], [0.82, 0.77]];
  return (
    <>
      <div className={`technology-list-section section-gap ${classes}`} id={props.id ? props.id : ''} onLoad={setValues}>
        <div className="platform section-gap-small">
          <div className="container">
            <h2>Our Technology Stack</h2>
            <div className="platform-inner">
              <div className="row d-flex flex-wrap align-v-center">
                <div className="col technology-title-bar">
                  <h6>PLATFORMS</h6>
                </div>
                <div className="col technology-list-bar d-flex flex-wrap align-v-center justify-space">
                  {platforms.map((platform, index) => {
                    return (<Parallax id={"technology-list-bar" + index} key={index} classes="grid-item" triggers={triggers[index]} length={50} opacity={true}>
                      <div className="d-flex align-v-center">
                        <div className="grid-icon">
                          <i>{platform.icon}</i>
                        </div>
                        <div className="grid-item-content">
                          <h3>{platform.title}</h3>
                        </div>
                      </div>
                    </Parallax>);
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <ul className="technology-list">
            {isMobile && <> <Slider {...settings}>
              {items.map((item, index) => {
                return (<li key={index}>
                  <div>
                    <i>{item.image}</i><p>{item.name}</p>
                  </div>
                </li>);
              })}
            </Slider></>}
            {!isMobile && <>
              {items.map((item, index) => {
                return (<Parallax id={"technology-list-item" + index} key={index} triggers={triggers2[index]} length={50} opacity={true}>
                  <motion.li key={index}>
                    <div>
                      <i>{item.image}</i><p>{item.name}</p>
                    </div>
                  </motion.li>
                </Parallax>);
              })}
            </>}
          </ul>
        </div>
      </div>
    </>
  );
}